/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Chip,
  CardContent,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Menu
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import axiosInstance from '../../helper/AxiosInstance';
import * as XLSX from 'xlsx';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";

// Import Chart.js components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Add this function to get track names
const getTrackName = (trackNumber) => {
  const trackNames = {
    1: "Structures & Materials 1",
    2: "Structures & Materials 2",
    3: "Vehicle Dynamics",
    4: "System Dynamics & Machinery",
    5: "Fluids & Co-Simulation",
    6: "Virtual Manufacturing"
  };
  return trackNames[trackNumber] || `Track ${trackNumber}`;
};

const TrackAdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [openJudgeDialog, setOpenJudgeDialog] = useState(false);
  const [openPresentationDialog, setOpenPresentationDialog] = useState(false);
  const [judgeData, setJudgeData] = useState({
    userEmail: '',
    userPassword: '',
    userName: '',
    userRole: ''
  });
  const [adminData, setAdminData] = useState(() => {
    const stored = sessionStorage.getItem('userData');
    return stored ? JSON.parse(stored) : {};
  });
  const [showJudgePassword, setShowJudgePassword] = useState(false);
  const userTrack = Number(adminData.userTrack) || 1;

  const [presentationData, setPresentationData] = useState({
    paperNumber: '',
    timeFrom: '',
    timeTo: '',
    title: '',
    authorName: '',
    authorEmail: '',
    organization: '',
    date: '',
    day: '',
    track: userTrack
  });
  const [loading, setLoading] = useState({
    judges: false,
    presentations: false,
    submission: false
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [judges, setJudges] = useState([]);
  const [presentations, setPresentations] = useState({ day1: [], day2: [] });
  const [selectedJudge, setSelectedJudge] = useState("");
  const [scores, setScores] = useState({ day1: [], day2: [] });

  const fetchJudges = async () => {
    try {
      setLoading(prev => ({ ...prev, judges: true }));
      const response = await axiosInstance.get('/scoring/fetchalluser');
      if (response.data?.userList) {
        const trackJudges = response.data.userList.filter(
          user => user.userTrack === userTrack && user.userRole.startsWith('j')
        );
        setJudges(trackJudges);
        if (trackJudges.length > 0) {
          setSelectedJudge(trackJudges[0].userRole);
        }
      }
    } catch (err) {
      setError('Failed to fetch judges');
    } finally {
      setLoading(prev => ({ ...prev, judges: false }));
    }
  };

  const fetchScores = async (judgeRole) => {
    try {
      const res = await axiosInstance.get(
        `/scoring/fetchprasentationbyjudge?role=${judgeRole}&track=${userTrack}`
      );
      if (res.data?.userList) {
        const day1 = res.data.userList.filter(p => Number(p.day) === 1);
        const day2 = res.data.userList.filter(p => Number(p.day) === 2);
        setScores({ day1, day2 });
      }
    } catch (err) {
      console.error("Failed to fetch scores", err);
    }
  };

  useEffect(() => {
    if (selectedJudge) {
      fetchScores(selectedJudge);
    }
  }, [selectedJudge]);

  const fetchPresentations = async () => {
    try {
      setLoading(prev => ({ ...prev, presentations: true }));
      const response = await axiosInstance.get(`/scoring/fetchprasentationbytrack?track=${userTrack}`);
      if (response.data?.userList) {
        const day1 = response.data.userList.filter(p => p.day === 1);
        const day2 = response.data.userList.filter(p => p.day === 2);
        setPresentations({ day1, day2 });
      }
    } catch (err) {
      setError('Failed to fetch presentations');
    } finally {
      setLoading(prev => ({ ...prev, presentations: false }));
    }
  };

  useEffect(() => {
    document.body.style.fontFamily = "'Poppins', sans-serif";
    fetchJudges();
    fetchPresentations();
  }, [userTrack]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAddJudge = async () => {
    try {
      setLoading(prev => ({ ...prev, submission: true }));
      setError('');
      setSuccess('');
      const payload = {
        ...judgeData,
        userTrack: userTrack
      };
      const response = await axiosInstance.post('/scoring/adduser', payload);
      if (response.data.status) {
        setSuccess('Judge added successfully!');
        fetchJudges();
        setJudgeData({
          userEmail: '',
          userPassword: '',
          userName: '',
          userRole: ''
        });
        setTimeout(() => setOpenJudgeDialog(false), 1500);
      } else {
        setError(response.data.statusMessage || 'Failed to add judge');
      }
    } catch (err) {
      setError('Error adding judge');
    } finally {
      setLoading(prev => ({ ...prev, submission: false }));
    }
  };

  const handleCloseJudgeDialog = () => {
    setJudgeData({
      userEmail: '',
      userPassword: '',
      userName: '',
      userRole: ''
    });
    setOpenJudgeDialog(false);
    setError('');
    setSuccess('');
  }

  const handleAddPresentation = async () => {
    try {
      setLoading(prev => ({ ...prev, submission: true }));
      setError('');
      setSuccess('');
      const payload = {
        ...presentationData,
        track: userTrack,
        scoringStatus: "Pending"
      };
      const response = await axiosInstance.post('/scoring/addprasentation', payload);
      if (response.data.status) {
        setSuccess('Presentation added successfully!');
        fetchPresentations();
        setPresentationData({
          paperNumber: '',
          timeFrom: '',
          timeTo: '',
          title: '',
          authorName: '',
          authorEmail: '',
          organization: '',
          date: '',
          day: activeTab === 1 ? 1 : 2,
          track: userTrack
        });
        setTimeout(() => setOpenPresentationDialog(false), 1500);
      } else {
        setError(response.data.statusMessage || 'Failed to add presentation');
      }
    } catch (err) {
      setError('Error adding presentation');
    } finally {
      setLoading(prev => ({ ...prev, submission: false }));
    }
  };

  const handleClosePresentationDialog = () => {
    setPresentationData({
      paperNumber: '',
      timeFrom: '',
      timeTo: '',
      title: '',
      authorName: '',
      authorEmail: '',
      organization: '',
      date: '',
      day: activeTab === 1 ? 1 : 2,
      track: userTrack
    });
    setOpenPresentationDialog(false);
    setError('');
    setSuccess('');
  };

  const [top3List, setTop3List] = useState([]);

  useEffect(() => {
    if (activeTab === 4) {
      fetchTop3();
    }
  }, [activeTab]);

  const fetchTop3 = async () => {
    try {
      const res = await axiosInstance.get(`/scoring/fetchtop3prasentationbyscore?track=${userTrack}`);
      if (res.data?.userList) {
        setTop3List(res.data.userList);
      }
    } catch (error) {
      console.error("Error fetching top 3:", error);
    }
  };

  const [approvalStatus, setApprovalStatus] = useState(false);

  // Fetch approval status when Scores tab opens
  useEffect(() => {
    if (activeTab === 3) {
      fetchApprovalStatus();
    }
  }, [activeTab, userTrack]);

  const fetchApprovalStatus = async () => {
    try {
      const res = await axiosInstance.get(`/scoring/fetchresultapprovalbytrack?track=${userTrack}`);
      if (res.data?.body?.approved) {
        setApprovalStatus(true);
      } else {
        setApprovalStatus(false);
      }
    } catch (err) {
      console.error("Error fetching approval status:", err);
    }
  };

  const handleApprove = async () => {
    try {
      const res = await axiosInstance.post(`/scoring/updateresultapprovalbytrack?track=${userTrack}`);
      if (res.data?.body?.approved) {
        setApprovalStatus(true);
      }
    } catch (err) {
      console.error("Error approving result:", err);
    }
  };

  const prepareChartData = (presentation) => {
    const categories = [
      'Business Value',
      'Complexity',
      'Interpretation',
      'Business Context',
      'Presentation Quality'
    ];

    const judge1Data = [
      parseInt(presentation.j1BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j1ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j1InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j1BusinessAndEngineeringContext || 0),
      parseInt(presentation.j1PresentationQualityandDeliveryStyle || 0)
    ];

    const judge2Data = [
      parseInt(presentation.j2BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j2ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j2InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j2BusinessAndEngineeringContext || 0),
      parseInt(presentation.j2PresentationQualityandDeliveryStyle || 0)
    ];

    const judge3Data = [
      parseInt(presentation.j3BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j3ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j3InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j3BusinessAndEngineeringContext || 0),
      parseInt(presentation.j3PresentationQualityandDeliveryStyle || 0)
    ];

    return {
      labels: categories,
      datasets: [
        {
          label: presentation.j1Name || 'Judge 1',
          data: judge1Data,
          backgroundColor: 'rgba(255, 99, 132, 0.8)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
        {
          label: presentation.j2Name || 'Judge 2',
          data: judge2Data,
          backgroundColor: 'rgba(54, 162, 235, 0.8)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
        {
          label: presentation.j3Name || 'Judge 3',
          data: judge3Data,
          backgroundColor: 'rgba(75, 192, 192, 0.8)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: 20
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 14
        },
        padding: 10,
        boxPadding: 5
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 10,
        title: {
          display: true,
          text: 'Score',
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: { top: 10, bottom: 10 }
        },
        ticks: {
          font: {
            size: 12
          },
          stepSize: 1
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Evaluation Categories',
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: { top: 10, bottom: 10 }
        },
        ticks: {
          font: {
            size: 12,
            weight: 'bold'
          }
        },
        grid: {
          display: false
        }
      }
    },
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: 'easeOutQuart'
    }
  };

  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleLogoutConfirm = () => {
    sessionStorage.removeItem('userData');
    navigate('/login');
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [openJudgeDelete, setOpenJudgeDelete] = useState(false);

  const handleMenuOpen = (event, judge) => {
    setAnchorEl(event.currentTarget);
    setSelectedJudge(judge);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedJudge(null);
  };

  const handleDeleteClick = () => {
    setOpenJudgeDelete(true);
    setAnchorEl(null);
  };

  const handleJudgeDelete = async () => {
    setOpenJudgeDelete(false);
    if (selectedJudge) {
      try {
        await axiosInstance.delete(`/scoring/deleteuserbyid?id=${selectedJudge.id}`);
        fetchJudges(); // refresh judges list
      } catch (error) {
        console.error("Error deleting judge:", error);
      }
    }
  };

  const [openPresentationDelete, setOpenPresentationDelete] = useState(false);
  const [selectedPresentation, setSelectedPresentation] = useState(null);

  const handlePresentationDelete = async () => {
    setOpenPresentationDelete(false);
    if (selectedPresentation) {
      try {
        await axiosInstance.delete(
          `/scoring/deleteprasentationbyid?id=${selectedPresentation.id}`
        );
        fetchPresentations(); // Refresh after delete
        setSuccess("Presentation deleted successfully");
      } catch (error) {
        console.error("Error deleting presentation:", error);
        setError("Failed to delete presentation");
      } finally {
        setOpenPresentationDelete(false);
      }
    }
  };

  // Function to handle Excel download
  const handleDownloadExcel = () => {
    // Combine Day 1 & Day 2 scores
    const day1Data = scores.day1.map((p) => ({
      Day: "Day 1",
      Title: p.title,
      Presenter: p.authorName,
      Organization: p.organization,
      "Business Value (x5)": p.businessValueDiscussionAndAchievement || "-",
      "Complexity Tech Solutions (x3)": p.complexityOfTechnicalSolutions || "-",
      "Interpretation of Results (x3)": p.interpretationOfResultsAndConclusion || "-",
      "Business & Eng. Context (x2)": p.businessAndEngineeringContext || "-",
      "Presentation Quality (x3)": p.presentationQualityandDeliveryStyle || "-",
    }));

    const day2Data = scores.day2.map((p) => ({
      Day: "Day 2",
      Title: p.title,
      Presenter: p.authorName,
      Organization: p.organization,
      "Business Value (x5)": p.businessValueDiscussionAndAchievement || "-",
      "Complexity Tech Solutions (x3)": p.complexityOfTechnicalSolutions || "-",
      "Interpretation of Results (x3)": p.interpretationOfResultsAndConclusion || "-",
      "Business & Eng. Context (x2)": p.businessAndEngineeringContext || "-",
      "Presentation Quality (x3)": p.presentationQualityandDeliveryStyle || "-",
    }));

    const allData = [...day1Data, ...day2Data];

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(allData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Scores");

    // Save Excel file
    const fileName = `${getTrackName(userTrack)}-${selectedJudge}-Scores.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#faf9f6' }}>
      <AppBar position="sticky" sx={{ background: "linear-gradient(to right, #1976d2, #42a5f5)" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Track : {getTrackName(userTrack)} - Admin Dashboard
          </Typography>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => setOpenLogoutDialog(true)}
            startIcon={<LogoutIcon />}
            sx={{
              borderRadius: 50,
              textTransform: "none",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 3, flex: 1 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{
            px: 2,
            '& .MuiTab-root': {
              fontWeight: 600,
              minWidth: 'auto',
              mr: { xs: 1, sm: 2, md: 3 },
            },
          }}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Judges" />
          <Tab label="Day 1 Presentations" />
          <Tab label="Day 2 Presentations" />
          <Tab label="Scores" />
          <Tab label="Winners" />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ p: 4 }}>
          {/* Judges Tab */}
          {activeTab === 0 && (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                  Judges - {getTrackName(userTrack)}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => setOpenJudgeDialog(true)}
                  sx={{
                    borderRadius: 20,
                    fontWeight: 600,
                    border: "1px solid #3db4e9",
                  }}
                >
                  Add Judge
                </Button>
              </Box>

              {loading.judges ? (
                <CircularProgress />
              ) : judges.length > 0 ? (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                    gap: 2,
                  }}
                >
                  {judges.map((judge) => (
                    <Card
                      key={judge.id}
                      sx={{
                        borderRadius: 2,
                        boxShadow: 3,
                        "&:hover": { boxShadow: 6 },
                        minHeight: 110,
                        position: "relative",
                      }}
                    >
                      {/* 3 Dots Menu at top right */}
                      <IconButton
                        onClick={(e) => handleMenuOpen(e, judge)}
                        sx={{
                          position: "absolute",
                          top: 2,
                          right: 0,
                        }}
                      >
                        <MoreVertIcon sx={{ fontSize: 20, }} />
                      </IconButton>

                      <CardContent>
                        <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                          Name :{" "}
                          <span style={{ fontWeight: 500 }}>
                            {judge.userName}
                          </span>
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                          Email :{" "}
                          <span style={{ fontWeight: 500 }}>
                            {judge.userEmail}
                          </span>
                        </Typography>
                      </CardContent>
                    </Card>
                  ))}
                </Box>
              ) : (
                <Typography sx={{ fontSize: 18, fontWeight: 500, color: "gray" }}>
                  No judges found
                </Typography>
              )}

              {/* Menu */}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleDeleteClick} sx={{ fontWeight: 600 }}>Delete</MenuItem>
              </Menu>
            </>
          )}

          {/* Presentations Tab */}
          {(activeTab === 1 || activeTab === 2) && (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                  {activeTab === 1 ? "Day 1" : "Day 2"} Presentations -{" "}
                  {getTrackName(userTrack)}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setSuccess("");
                    setError("");
                    setPresentationData({
                      ...presentationData,
                      day: activeTab === 1 ? 1 : 2,
                      track: userTrack,
                    });
                    setOpenPresentationDialog(true);
                  }}
                  disabled={loading.submission}
                  sx={{
                    borderRadius: 20,
                    fontWeight: 600,
                    border: "1px solid #3db4e9",
                  }}
                >
                  Add Presentation
                </Button>
              </Box>

              {loading.presentations ? (
                <CircularProgress />
              ) : presentations[activeTab === 1 ? "day1" : "day2"].length > 0 ? (
                <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3 }}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ background: "linear-gradient(45deg, #a8edea, #fed6e3)" }}>
                        <TableCell sx={{ fontWeight: 600 }}>Time Slot</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Author</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Organization</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {presentations[activeTab === 1 ? "day1" : "day2"]
                        .slice()
                        .sort((a, b) => {
                          // assuming timeFrom is in HH:mm format (24hr)
                          const timeA = new Date(`1970-01-01T${a.timeFrom}:00`);
                          const timeB = new Date(`1970-01-01T${b.timeFrom}:00`);
                          return timeA - timeB;
                        })
                        .map((presentation) => (
                          <TableRow key={presentation.id}>
                            <TableCell>
                              <Box sx={{ display: "flex", alignItems: "center" }}>
                                <ScheduleIcon color="primary" sx={{ mr: 1 }} />
                                {presentation.timeFrom} - {presentation.timeTo}
                              </Box>
                            </TableCell>
                            <TableCell>{presentation.title}</TableCell>
                            <TableCell>
                              {presentation.authorName}
                              <Typography variant="body2" color="text.secondary">
                                {presentation.authorEmail}
                              </Typography>
                            </TableCell>
                            <TableCell>{presentation.organization}</TableCell>
                            <TableCell>
                              <IconButton
                                color="error"
                                onClick={() => {
                                  setSelectedPresentation(presentation);
                                  setOpenPresentationDelete(true);
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: 22 }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography
                  sx={{ fontSize: 18, fontWeight: 500, color: "gray" }}
                >
                  No presentations scheduled for this day
                </Typography>
              )}
            </>
          )}

          {/* Scores Tab */}
          {activeTab === 3 && (
            <>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: { xs: "center", sm: "center" },
                  gap: 2,
                  mb: 3,
                }}
              >
                {/* Left Side: Title */}
                <Typography
                  sx={{
                    fontSize: { xs: 16, sm: 18 },
                    fontWeight: 600,
                    textAlign: { xs: "center", sm: "left" },
                    flex: 1,
                  }}
                >
                  Scores of Each Judges - {getTrackName(userTrack)}
                </Typography>

                {/* Right Side: Button + Dropdown */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadExcel}
                    sx={{
                      borderRadius: 8,
                      fontWeight: 600,
                      backgroundColor: "#499167",
                      fontSize: { xs: "0.85rem", sm: "0.95rem" },
                      width: { xs: "100%", sm: "auto" }, // Full width on mobile
                    }}
                  >
                    Download Scores
                  </Button>

                  <FormControl
                    size="small"
                    sx={{
                      minWidth: { xs: "100%", sm: 150 },
                    }}
                  >
                    <Select
                      value={selectedJudge}
                      onChange={(e) => setSelectedJudge(e.target.value)}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        fontWeight: "600",
                        fontSize: { xs: "0.85rem", sm: "0.95rem" },
                      }}
                    >
                      {judges.length === 0 ? (
                        <MenuItem value="" disabled sx={{ fontSize: "0.95rem", fontWeight: 600 }}>
                          No Judges
                        </MenuItem>
                      ) : (
                        judges.map((judge) => (
                          <MenuItem
                            key={judge.id}
                            value={judge.userRole}
                            sx={{ fontSize: "0.95rem", fontWeight: 600 }}
                          >
                            {judge.userName}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Day 1 Table */}
              <Typography sx={{ mb: 2, fontSize: 18, fontWeight: 500 }}>
                Day - 1 Scores
              </Typography>
              <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mb: 4 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ background: "linear-gradient(45deg, #a8edea, #fed6e3)" }}>
                      <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Presenter</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Organization</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Business Value (wg:x5)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Complexity Tech Solutions (wg:x3)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Interpretation of results (wg:x3)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Business & Eng. Context (wg:x2)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Presentation Quality (wg:x3)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scores.day1.length > 0 ? (
                      scores.day1.map((p) => (
                        <TableRow key={p.id}>
                          <TableCell>{p.title}</TableCell>
                          <TableCell>{p.authorName}</TableCell>
                          <TableCell>{p.organization}</TableCell>
                          <TableCell align='center'>{p.businessValueDiscussionAndAchievement || "-"}</TableCell>
                          <TableCell align='center'>{p.complexityOfTechnicalSolutions || "-"}</TableCell>
                          <TableCell align='center'>{p.interpretationOfResultsAndConclusion || "-"}</TableCell>
                          <TableCell align='center'>{p.businessAndEngineeringContext || "-"}</TableCell>
                          <TableCell align='center'>{p.presentationQualityandDeliveryStyle || "-"}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No scores found for Day 1
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Day 2 Table */}
              <Typography sx={{ mb: 2, fontSize: 18, fontWeight: 500 }}>
                Day - 2 Scores
              </Typography>
              <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mb: 4 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ background: "linear-gradient(45deg, #a8edea, #fed6e3)" }}>
                      <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Presenter</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Organization</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Business Value (wg:x5)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Complexity Tech Solutions (wg:x3)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Interpretation of results (wg:x3)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Business & Eng. Context (wg:x2)</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Presentation Quality (wg:x3)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scores.day2.length > 0 ? (
                      scores.day2.map((p) => (
                        <TableRow key={p.id}>
                          <TableCell>{p.title}</TableCell>
                          <TableCell>{p.authorName}</TableCell>
                          <TableCell>{p.organization}</TableCell>
                          <TableCell align='center'>{p.businessValueDiscussionAndAchievement || "-"}</TableCell>
                          <TableCell align='center'>{p.complexityOfTechnicalSolutions || "-"}</TableCell>
                          <TableCell align='center'>{p.interpretationOfResultsAndConclusion || "-"}</TableCell>
                          <TableCell align='center'>{p.businessAndEngineeringContext || "-"}</TableCell>
                          <TableCell align='center'>{p.presentationQualityandDeliveryStyle || "-"}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No scores found for Day 2
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Approval Button */}
              <Box sx={{ textAlign: "center", mt: 3 }}>
                {approvalStatus ? (
                  <Button
                    variant="contained"
                    color="success"
                    disabled
                    sx={{ borderRadius: 2, fontWeight: 600 }}
                  >
                    ✅ Approved
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApprove}
                    sx={{ borderRadius: 2, fontWeight: 600 }}
                  >
                    Approve Final Result
                  </Button>
                )}
              </Box>
            </>
          )}

          {/* Winners Tab */}
          {activeTab === 4 && (
            <Box>
              <Typography sx={{ fontSize: 20, fontWeight: 600, mb: 3 }}>
                Top 3 Presentations Winners - {getTrackName(userTrack)}
              </Typography>

              {/* ✅ Check approval first */}
              {!approvalStatus ? (
                <Typography sx={{ fontSize: 18, fontWeight: 500, color: "gray" }}>
                  Final Results not yet approved by Admin
                </Typography>
              ) : (
                <>
                  {/* ✅ Approved label + Download button in same row */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 3,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: "#1c6747",
                      }}
                    >
                      ✅ Approved by Admin
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ borderRadius: 8, fontWeight: 600, backgroundColor: "#499167" }}
                      onClick={() => {
                        const exportData = top3List.map((item) => ({
                          Rank: item.rank,
                          Name: item.presentation.authorName,
                          Title: item.presentation.title,
                          Day: item.presentation.day,
                          "Final Score": item.finalScore,
                        }));
                        const worksheet = XLSX.utils.json_to_sheet(exportData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Top 3 Winners");
                        XLSX.writeFile(workbook, "Top3Winners.xlsx");
                      }}
                    >
                      Download Excel
                    </Button>
                  </Box>

                  {top3List.length > 0 ? (
                    <>
                      {/* --- Your Winners Table --- */}
                      <TableContainer
                        component={Paper}
                        sx={{ borderRadius: 3, boxShadow: 3, mb: 4 }}
                      >
                        <Table>
                          <TableHead>
                            <TableRow sx={{ background: "linear-gradient(45deg, #a8edea, #fed6e3)", }}>
                              <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>
                                Rank
                              </TableCell>
                              <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>
                                Name
                              </TableCell>
                              <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>
                                Title
                              </TableCell>
                              <TableCell
                                sx={{ fontSize: 16, fontWeight: 600 }}
                                align="center"
                              >
                                Day
                              </TableCell>
                              <TableCell
                                sx={{ fontSize: 16, fontWeight: 600 }}
                                align="center"
                              >
                                Total Score
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {top3List.map((item) => (
                              <TableRow key={item.presentation.id}>
                                <TableCell>
                                  <Box
                                    sx={{
                                      backgroundColor:
                                        item.rank === 1
                                          ? "#388e3c"
                                          : item.rank === 2
                                            ? "#9c27b0"
                                            : "#2196f3",
                                      color: "#fff",
                                      px: 1.5,
                                      py: 0.5,
                                      borderRadius: "16px",
                                      fontWeight: "bold",
                                      display: "inline-block",
                                      textAlign: "center",
                                      minWidth: "32px",
                                    }}
                                  >
                                    #{item.rank}
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }}>
                                  {item.presentation.authorName}
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }}>
                                  {item.presentation.title}
                                </TableCell>
                                <TableCell
                                  sx={{ fontSize: 18, fontWeight: 500 }}
                                  align="center"
                                >
                                  {item.presentation.day}
                                </TableCell>
                                <TableCell
                                  sx={{ fontSize: 18, fontWeight: 500 }}
                                  align="center"
                                >
                                  {item.finalScore}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      {/* --- Category Wise Chart --- */}
                      <Typography
                        variant="h4"
                        sx={{
                          mt: 4,
                          mb: 3,
                          fontWeight: 600,
                          textAlign: "center",
                          color: "#2c3e50",
                          fontSize: 24,
                        }}
                      >
                        Category-wise Scores by Judges
                      </Typography>

                      <Grid container fullWidth spacing={3} sx={{ mb: 4 }}>
                        {top3List.map((item) => (
                          <Grid item xs={12} key={item.presentation.id}>
                            <Box
                              sx={{
                                mb: 3,
                                p: 2.5,
                                width: "100%",
                                maxWidth: "850px",
                                mx: "auto",
                                backgroundColor: "#fafafa",
                                borderRadius: 2,
                                border: "1px solid #eeeeee",
                              }}
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
                              >
                                <Box
                                  sx={{
                                    backgroundColor: "#e0e0e0",
                                    color: "#2d3436",
                                    width: 42,
                                    height: 42,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bold",
                                    fontSize: 18,
                                    mr: 3,
                                  }}
                                >
                                  #{item.rank}
                                </Box>
                                <Box>
                                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    {item.presentation.authorName}
                                  </Typography>
                                  <Typography variant="body1" sx={{ color: "#757575" }}>
                                    {item.presentation.title}
                                  </Typography>
                                </Box>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  mt: 2,
                                  pt: 2,
                                  borderTop: "1px solid #eeeeee",
                                }}
                              >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <ScheduleIcon sx={{ mr: 1, color: "#616161" }} />
                                  <Typography variant="body2">
                                    Day {item.presentation.day}
                                  </Typography>
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "medium" }}
                                  >
                                    Final Score:
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: "bold", ml: 1 }}
                                  >
                                    {item.finalScore}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                height: 400,
                                width: "100%",
                                p: 1,
                                backgroundColor: "white",
                                borderRadius: 2,
                                boxShadow: 3,
                              }}
                            >
                              <Bar
                                data={prepareChartData(item.presentation)}
                                options={chartOptions}
                              />
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  ) : (
                    <Typography
                      sx={{ fontSize: 18, fontWeight: 500, color: "gray" }}
                    >
                      No winners found
                    </Typography>
                  )}
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* Add Judge Dialog */}
      <Dialog open={openJudgeDialog} onClose={handleCloseJudgeDialog} maxWidth="sm" fullWidth>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddJudge();
          }}
        >
          <DialogTitle sx={{ fontSize: 18, fontWeight: 600 }}>
            Add New Judge for {getTrackName(userTrack)}
          </DialogTitle>
          <DialogContent>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Judge Name</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={judgeData.userName}
                onChange={(e) => setJudgeData({ ...judgeData, userName: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Email</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={judgeData.userEmail}
                onChange={(e) => setJudgeData({ ...judgeData, userEmail: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Password</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                type={showJudgePassword ? 'text' : 'password'}
                value={judgeData.userPassword}
                onChange={(e) => setJudgeData({ ...judgeData, userPassword: e.target.value })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowJudgePassword(!showJudgePassword)}
                        edge="end"
                      >
                        {showJudgePassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Role (j1, j2, etc.)</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={judgeData.userRole}
                onChange={(e) => setJudgeData({ ...judgeData, userRole: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseJudgeDialog} sx={{ fontWeight: 600 }}>Cancel</Button>
            <Button
              type="submit"
              variant="outlined"
              sx={{ fontWeight: 600, borderRadius: 16 }}
              disabled={loading.submission}
            >
              {loading.submission ? <CircularProgress size={20} /> : "Add Judge"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Add Presentation Dialog */}
      <Dialog open={openPresentationDialog} onClose={handleClosePresentationDialog} maxWidth="sm" fullWidth>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddPresentation();
          }}
        >
          <DialogTitle sx={{ fontSize: 18, fontWeight: 600, }}>Add New Presentation for {getTrackName(userTrack)}</DialogTitle>
          <DialogContent>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Title</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={presentationData.title}
                onChange={(e) => setPresentationData({ ...presentationData, title: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Author Name</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={presentationData.authorName}
                onChange={(e) => setPresentationData({ ...presentationData, authorName: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Author Email</span>
                  </>
                }
                type="email"
                value={presentationData.authorEmail}
                onChange={(e) => setPresentationData({ ...presentationData, authorEmail: e.target.value })}
              />
              <TextField
                fullWidth
                label={
                  <>
                    <span style={{ fontSize: '14px', fontWeight: 600 }}>Organization</span>
                    <span style={{ color: 'red' }}> *</span>
                  </>
                }
                value={presentationData.organization}
                onChange={(e) => setPresentationData({ ...presentationData, organization: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                type="date"
                value={presentationData.date}
                onChange={(e) => setPresentationData({ ...presentationData, date: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                type="time"
                value={presentationData.timeFrom}
                onChange={(e) => setPresentationData({ ...presentationData, timeFrom: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
              <TextField
                fullWidth
                type="time"
                value={presentationData.timeTo}
                onChange={(e) => setPresentationData({ ...presentationData, timeTo: e.target.value })}
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      display: "none", // hides default *
                    },
                  },
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePresentationDialog} sx={{ fontWeight: 600, }}>Cancel</Button>
            <Button type="submit" variant="outlined" sx={{ fontWeight: 600, borderRadius: 16 }} disabled={loading.submission}>
              {loading.submission ? <CircularProgress size={20} /> : 'Add Presentation'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Logout Delete Dialog */}
      <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)} maxWidth="xs" fullWidth>
        <DialogContent>
          <Typography sx={{ fontWeight: 600 }}>Are you sure you want to logout ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenLogoutDialog(false)} sx={{ fontWeight: 600 }}>
            Cancel
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            color="error"
            variant="outlined"
            sx={{ fontWeight: 600, borderRadius: 16 }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* Judge Delete Dialog */}
      <Dialog open={openJudgeDelete} onClose={() => setOpenJudgeDelete(false)}>
        <DialogContent>
          <Typography sx={{ fontWeight: 600 }}>
            Are you sure you want to delete{" "} {selectedJudge?.userName} ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenJudgeDelete(false)} sx={{ fontWeight: 600 }}>Cancel</Button>
          <Button
            color="error"
            onClick={handleJudgeDelete}
            variant="outlined"
            sx={{ fontWeight: 600, borderRadius: 16 }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Presentation Delete Dialog */}
      <Dialog open={openPresentationDelete} onClose={() => setOpenPresentationDelete(false)}>
        <DialogContent>
          <Typography sx={{ fontWeight: 600 }}>
            Are you sure you want to delete presentation ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPresentationDelete(false)} sx={{ fontWeight: 600 }}>
            Cancel
          </Button>
          <Button color="error" variant="outlined" onClick={handlePresentationDelete} sx={{ fontWeight: 600, borderRadius: 16 }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TrackAdminDashboard;